import React from "react";
import { useParams } from "react-router-dom";
import { SpendingListViewV2, ItemSpending } from "../../../spending/component/SpendingList/SpendingListView/SpendingListView";
import { dateConverter } from "../../../../utils/dateConverter";
import { useSpendingDemandSpendingList } from "../../hooks";
import { Spending } from "../../../spending/types/spending.types";
import { spedingStatusRawToReadableStatus } from "../../../spending/utils/spendingStatusConverter";
import UserInfo from "../../../user/components/UserInfo";
import ProjectInfo from "../../../project/components/ProjectInfo";
import EmptyListIcon from "../../../../components/atoms/EmptyListIcon/EmptyListIcon";
import Loader from "../../../../components/atoms/Loader/Loader";
import PaginationV2 from "../../../../components/organismes/PaginationV2/PaginationV2";
import { IconType } from "../../../../assets/JWayIcons";
import useSpending from "../../../spending/hooks/useSpending";
import useNavigationApp from "../../../../navigation/hook/useNavigationApp";

export interface SpendingListPresenterProps {
  spendingDemandId?: string;
  withSelectMode?: boolean;
  forUser?: boolean;
  pageSize?: number;
}

export default function SpendingListPresenter({
  spendingDemandId: spendingDemandIdProp,
  withSelectMode,
  forUser,
  pageSize = 10
}: SpendingListPresenterProps) {
  const { spendingDemandId: spendingDemandIdParam } = useParams();
  const spendingDemandId = spendingDemandIdProp || spendingDemandIdParam || "";
  
  const { getAllQuery } = useSpendingDemandSpendingList(spendingDemandId, {
    pageSize,
  });

  const { spendingCategorieList } = useSpending();
  const { goToSpending, goToSpendingUser } = useNavigationApp();

  const { data: spendingListData, isLoading } = getAllQuery;
  const pagination = spendingListData?.pagination;

  const handleClick = (spendingId: string) => {
    if (forUser) {
      goToSpendingUser(spendingId);
    } else {
      goToSpending(spendingId);
    }
  };

  // Helper function to get category name
  const getCategoryName = (categoryId: string): string => {
    if (!spendingCategorieList || !categoryId) return "";
    const category = spendingCategorieList.find(
      (cat: { category_id: string; category_name: string }) => cat.category_id === categoryId
    );
    return category?.category_name || "";
  };

  const formated: ItemSpending[] | undefined =
    spendingListData?.data?.map((spending: Spending) => {
      const statusObject = spedingStatusRawToReadableStatus(spending.spending_status);
      const categoryName = getCategoryName(spending.spending_category);

      return {
        id: spending.spending_id,
        title: spending.spending_desc,
        userFullNameRenderer: () => (
          <>
            <UserInfo id={spending.spending_user as any as string} info="username" limitText={10} />{" "}
            <UserInfo id={spending.spending_user as any as string} info="lastname" limitText={10} />{" "}
          </>
        ),
        projectNameRenderer: () => (
          <>
            <ProjectInfo id={spending.spending_project as any as string} info="project_name" limitText={10} />{" "}
          </>
        ),
        createdDate: dateConverter(spending.spending_date),
        grossAmmount: spending.spending_amountTTC,
        status: statusObject.status,
        projectName: spending.spending_project,
        category: categoryName,
        colorStatus: {
          backgroundColor: statusObject.color.light,
          color: statusObject.color.dark,
          iconType: undefined as IconType | undefined,
        },
        withPin: false,
        onClick: () => handleClick(spending.spending_id),
      };
    });

  if (isLoading) {
    return <Loader paddingTop="20%" centered />;
  }

  if (!formated) {
    return <EmptyListIcon message="Une erreur est survenue" />;
  }

  if (formated && formated.length === 0) {
    return null;
  }

  return (
    <>
      <SpendingListViewV2
        spendingList={formated || []}
        isCheckMode={withSelectMode}
        noUser={forUser}
      />
      <PaginationV2
        centered
        currentPage={pagination?.current_page}
        lastPage={pagination?.total_pages}
        setCurrentPage={getAllQuery.setPage}
      />
    </>
  );
}
